module.exports = __webpack_public_path__ + "img/main.3aece2a4.png";